export default __webpack_public_path__ + "static/media/M&S 1.6bbac111.svg";